import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
let serverUrl = getSecret('SERVER_URL');
import i18n from '@plugins/i18n'

export const getters = {
  getMunicipalityFields() {
    return {model: 'geographics_municipality', 
            label: 'Municipalities',
            fields: [
                { key: 'name', label: 'Name', type: 'text', sortable: true, required: true },
                { key: 'code', label: 'DANE Code', type: 'readonly', sortable: true, required: true },
                { key: 'is_main', label: 'Is Main', type: 'boolean', sortable: true, required: true, formatter: (value, key, item) => {
                  return value ? i18n.t('basic.yes') : i18n.t('basic.no')
                }},
                { key: 'department', label: 'Department', type: 'model', 
                  model_source: 'Departments', model_route: 'management/masters/departments', 
                  sortable: true, required: false, formatter: (value, key, item) => {
                  return item.department.instance__name || item.department.name
                }}
              ]}
  },
}

export const actions = {
  async fetchMunicipalities(context, query = '') {
    return axios
      .get(`${serverUrl}/api/masters/municipalities/${query}`)
      .then((response) => {
        return response.data;
      })
  },

  async createMunicipalities(context, { payload }) {
    return axios
      .post(`${serverUrl}/api/masters/municipalities/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async updateMunicipalities(context, { payload }) {
    return axios
      .patch(`${serverUrl}/api/masters/municipalities/${payload.id}/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async deleteMunicipalities(context, { id }) {
    return axios
      .delete(`${serverUrl}/api/masters/municipalities/${id}/`)
      .then((response) => {
        return response.data;
      })
  },

  async fetchMunicipalitiesByTerritory(context, query = '') {
    return axios
      .get(`${serverUrl}/api/masters/municipalities/${query}`)
      .then((response) => {
        return response.data;
      })
  },
}